import script from "./forget.vue?vue&type=script&setup=true&lang=js"
export * from "./forget.vue?vue&type=script&setup=true&lang=js"

import "./forget.vue?vue&type=style&index=0&id=38241777&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38241777"]])

export default __exports__